<template>
  <!-- 行情介绍  港美股、A股行情详情 -->
  <div :class="`intro-quota-page ${detailType} ${detailType}-${t('curlan')} ${t('curlan')}`">
    <div :class="`banner-wrap ${detailType} ${t('curlan')}`">
      <p class="title1">{{t(`intro_quota.${detailType}.text_1`)}}</p>
      <div class="title2" v-html="t(`intro_quota.${detailType}.text_2`)"></div>
    </div>
    <div :class="`common-content-wrap table-content ${detailType}`">
      <div :class="`main-title  ${detailType}`">
        <span class="txt">{{t(`intro_quota.${detailType}.text_3`)}}</span>
      </div>
      <table :class="`table-${detailType}`" border="1px">
        <thead>
          <tr v-if="'cn' === detailType+''">
            <th></th>
            <th>{{t(`intro_quota.${detailType}.table_txt1`)}}</th>
          </tr>
          <tr v-else>
            <th></th>
            <th>{{t(`intro_quota.${detailType}.table_txt1`)}}</th>
            <th>{{t(`intro_quota.${detailType}.table_txt2`)}}</th>
          </tr>
        </thead>
        <tbody >
          <tr :key="`${detailType}-${index}-table-tr`" v-for="(item, index) in tableConfig">
            <td v-html="t(item.label)"></td>
            <td>
              <div class="td-wrap">
                <i :class="`iconfont icon-${item.col2_flag}`"></i>
                <span class="txt" v-html="t(item.col2)"></span>
              </div>
            </td>
            <td v-if="'cn' !== detailType+''">
              <div class="td-wrap">
                <i :class="`iconfont icon-${item.col3_flag}`"></i>
                <span class="txt" v-html="t(item.col3)"></span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <p style="font-size:.24rem;color:#999999;padding-top:.24rem;" v-if="detailType+'' === 'hk'">
      {{t('intro_quota.text_18')}}
      </p>
    </div>

    <div class="common-content-wrap">
      <div :class="`main-title  ${detailType}`">
        <span :class="`txt  ` ">{{t(`intro_quota.${detailType}.text_4`)}}</span>
      </div>
      <p class="title-desc">{{t(`intro_quota.${detailType}.text_5`)}}</p>
      <div class="gift-wrap time-sale">
        <div :class="`img-item `"></div>
      </div>
    </div>
    <div class="common-content-wrap">
      <div :class="`main-title  ${detailType}`">
        <span class="txt">{{t(`intro_quota.${detailType}.text_6`)}}</span>
      </div>
      <p class="title-desc">{{t(`intro_quota.${detailType}.text_7`)}}</p>
      <div class="gift-wrap bid-ask">
        <div :class="`img-item `"></div>
      </div>
    </div>
    
    <div class="common-content-wrap" v-if="detailType+'' === 'hk'">
      <div :class="`main-title  ${detailType}`">
        <span class="txt">{{t(`intro_quota.${detailType}.text_8`)}}</span>
      </div>
      <p class="title-desc">{{t(`intro_quota.${detailType}.text_9`)}}</p>
      <div class="gift-wrap broker">
        <div :class="`img-item `"></div>
      </div>
    </div>

  </div>
</template>
<script>

import { getParamObjFromUrl } from '@/utils/url.js'
import { quota_hk_config,quota_us_config,quota_cn_config } from '@/views/intro-quota/define.js'
import { computed, ref } from '@vue/reactivity'
import { onMounted } from '@vue/runtime-core'
import { useI18n } from 'vue-i18n'
export default {
  setup() {
    let { t } = useI18n()
    let detailType = ref('hk')
    let tableConfig = computed(()=>{
      let res = quota_hk_config
      switch(detailType.value){
        case 'hk':
          res = quota_hk_config
          break
        case 'us':
          res = quota_us_config
          break
        case 'cn':
          res = quota_cn_config
          break
      }
      return res
    })
    onMounted(()=>{
      let queryParams = getParamObjFromUrl()
      if(queryParams.dtype){
        let tempType = queryParams.dtype
        detailType.value = 'hk,us,cn'.indexOf(tempType)>-1?tempType:'hk' //
      }
      document.title = t('intro_quota.title')
    })
    return {
      detailType,
      tableConfig,
      t,
    }
  },
}
</script>
<style lang="stylus">
@import './hk-animation.styl'
@import './us-animation.styl'
@import './cn-animation.styl'
@import './style.styl'

</style>